// Mock chat messages for live broadcasting studio
export const MOCK_CHAT_MESSAGES = [
{
  id: 1,
  username: 'Александра Волкова',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_150783c18-1764682950879.png",
  avatarAlt: 'Professional woman with long brown hair in casual blue sweater smiling warmly',
  content: 'Отличный звук! Спасибо за эфир 🎧',
  timestamp: new Date(Date.now() - 300000),
  reaction: '❤️'
},
{
  id: 2,
  username: 'Дмитрий Соколов',
  avatar: "https://images.unsplash.com/photo-1659093728055-45f8275166d9",
  avatarAlt: 'Young man with short dark hair and beard wearing black t-shirt in studio setting',
  content: 'Когда следующий эфир планируется?',
  timestamp: new Date(Date.now() - 180000)
},
{
  id: 3,
  username: 'Елена Морозова',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_142d3c9bf-1763301932985.png",
  avatarAlt: 'Middle-aged woman with blonde hair in elegant white blouse with professional makeup',
  content: 'Очень глубокие мысли, продолжайте в том же духе',
  timestamp: new Date(Date.now() - 120000),
  reaction: '🙏'
}];


// Mock audio data
export const MOCK_CURRENT_AUDIO = {
  title: 'Философия присутствия',
  artist: 'Иван Петров',
  artwork: "https://images.unsplash.com/photo-1729161769741-e7bbb82abc84",
  artworkAlt: 'Abstract minimalist artwork with vertical lines representing sound waves',
  url: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3'
};

// Default metadata state
export const DEFAULT_METADATA = {
  title: '',
  description: '',
  category: 'talk',
  tags: '',
  privacy: 'public',
  allowComments: true,
  saveRecording: true,
  allowDownload: false
};

// Default audio settings
export const DEFAULT_AUDIO_SETTINGS = {
  inputDevice: 'default',
  bitrate: '192',
  noiseSuppression: true,
  echoCancellation: true,
  autoGainControl: true,
  monitoring: false
};

// Broadcast tips
export const BROADCAST_TIPS = [
{
  id: 1,
  text: 'Используйте качественный микрофон и наушники для предотвращения эха'
},
{
  id: 2,
  text: 'Проверьте стабильность интернет-соединения перед началом трансляции'
},
{
  id: 3,
  text: 'Заполните метаданные эфира для лучшей видимости в поиске'
},
{
  id: 4,
  text: 'Взаимодействуйте со слушателями через чат для создания вовлечённости'
}];


// Connection quality thresholds
export const CONNECTION_QUALITY = {
  EXCELLENT: { min: 90, label: 'excellent', color: 'var(--color-success)' },
  GOOD: { min: 70, label: 'good', color: 'var(--color-info)' },
  FAIR: { min: 50, label: 'fair', color: 'var(--color-warning)' },
  POOR: { min: 0, label: 'poor', color: 'var(--color-error)' }
};